import { Link as GatsbyLink, parsePath } from 'gatsby';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { pageMetadataForPath } from '../utils/page';

export default memo(
	/**
	 * @param {import("gatsby").GatsbyLinkProps<any>} param0
	 */
	function LocaleLink({to, ...restArgs}) {
		const {locale} = useIntl();

		if (to.startsWith('/')) {
			const location = parsePath(to);
			const metadata = pageMetadataForPath(location.pathname);
			if (metadata !== null) {
				const newPathname = (() => {
					if (locale && locale === 'en') {
						return metadata.pathEn;
					}
					return metadata.pathDe;
				})();

				return (
					<GatsbyLink
						to={`${newPathname}${location.search}${location.hash}`}
						{...restArgs}
					/>
				);
			}
		}

		return (
			<a href={to} {...restArgs} />
		);
	}
);
